import { render, staticRenderFns } from "./studentRegisterTalentComplete.vue?vue&type=template&id=1d9a0290&scoped=true"
import script from "./studentRegisterTalentComplete.vue?vue&type=script&lang=js"
export * from "./studentRegisterTalentComplete.vue?vue&type=script&lang=js"
import style0 from "./studentRegisterTalentComplete.vue?vue&type=style&index=0&id=1d9a0290&prod&scoped=true&lang=css"
import style1 from "./studentRegisterTalentComplete.vue?vue&type=style&index=1&id=1d9a0290&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9a0290",
  null
  
)

export default component.exports